import { has, have } from "../../../utils/menu-context";
import { commonInputPropField } from "../license-request/request/license/request-license.condition";
import store from "../../../store";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (record.isCanAppealLicense
                && !record.isHaveAppealedLicense
                && record.refLicenseStatus?.key == "revoke"
                && record.createBy == store.state.resource.auth.info.user?.username
            ) {
                result = true || result;
            }
            if (has({ menuContext, key: "canEdit" })) {
                result = true || result;
            }
            return result;
        },
        canAppealLicense: ({ record }) => {
            let result = false;
            if (record.createBy === store.state.resource.auth.info.user?.username
                && record.isCanAppealLicense
                && record.refLicenseStatus?.key == "revoke"
            ) {
                result = true || result;
            }
            return result;
        },
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return [
                    "refStatus",
                    "changeStatusRemark",
                ].includes(field?.key);
            },
            visibleField: ({ data }) => {
                return ["EDIT_LICENSE_STATUS"].includes(data.roleEdit);
            },
        },
        // Always hidden input field
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refVesselRequest+\\.(attachmentVesselIdentities|attachmentPositionVesselIdentities|attachmentHeadVessels|attachmentFullVessels)\\.(exampleAttachment|dividerAttachment)\\.[^\\.]$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refPrintStatus"
                ].includes(field?.key);
            },
            visibleField: ({ props }) => {
                const { menuContext } = props
                let isVisible = false;
                if (have({ menuContext, keys: ["forDofCenter", "forAuthorized"] })) {
                    isVisible = true;
                }
                return isVisible;
            },
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^refOrigin\\.refVesselRequest\\.[^\\.]+\\.attachment\\.[^\\.]$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "draftCode",
                    "requestCode",
                    "requestDate",
                    "isAttorney",
                    "isAttorneySpace",
                    "refAttorneyTitle",
                    "attorneyFirstName",
                    "attorneyFirstNameSpace",
                    "attorneyLastName",
                    "attorneyIdCard",
                    "attorneyPhoneNumber",
                    "cancelRequest",
                    "refRequesterLifeStatus",
                    "refOriginal.refFishingArea"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            },
        },
        // Always disable input field
        {
            check: ({ field }) => {
                return [
                    "licenseIssueDate",
                    "licenseExpiredDate",
                    "draftCode",
                    "draftCode",
                    "requestCode",
                    "requestDate",
                    "refRequesterNationality",
                    "refRequesterMobile",
                    "refRequesterEmail",
                    "refVesselRequest.name",
                    "refVesselRequest.tgross",
                    "refVesselRequest.tnange",
                    "refVesselRequest.vesselType",
                    "refVesselRequest.useType",
                    "refVesselRequest.licenseIssueDate",
                    "refVesselRequest.licenseExpireDate",
                    "refVesselRequest.registrationDate",
                    "refVesselRequest.lbp",
                    "refVesselRequest.loa",
                    "refVesselRequest.deep",
                    "refVesselRequest.breadth",
                    "refVesselRequest.licenseNumber",
                    "requesterAge",
                    "totalThaiWorkers",
                    "totalForeignWorkers",
                    "refRequesterPersonType",
                    "requesterIdCard",
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "refOwnerPersonType",
                    "ownerIdCard",
                    "refOwnerTitle",
                    "ownerFirstName",
                    "ownerLastName",
                    "refReceiveDept",
                    "refFishingArea",
                    "refVesselRequest.code",
                    "isThaiWorkers",
                    "isForeignWorkers",
                    "foreignMaleWorkers",
                    "foreignFemaleWorkers",
                    "thaiMaleWorkers",
                    "thaiFemaleWorkers",
                    "cancelRequest",
                    "ownerMobile",
                    "ownerEmail",
                    "ownerName",
                    "ownerShareholdingTh",
                    "refOwnerCompanyType",
                    "attachmentFeeSlips",
                    "attachmentDutySlips",
                    "refPaymentBank",
                    "refBankProvince",
                    "refPaymentMethod",
                    "payFeeAtDate",
                    "payDutyAtDate"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            },
        },
        {
            check: ({ field }) => {
                return [
                    "isThaiWorkers",
                    "isForeignWorkers",
                    "isApprovePayment"
                ].includes(field?.key);
            },
            checkboxField: () => {
                return { disabled: true };
            },
        },
        // Control การเห็น Field ตามประเภทบุคคล หรือ นิติบุคคล
        {
            check: ({ field }) => {
                return [
                    "refRequesterTitle",
                    "requesterFirstName",
                    "requesterFirstNameSpace",
                    "requesterLastName",
                    "refRequesterNationality",
                    "requesterAge",
                    "refRequesterLifeStatus"
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '2';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refOwnerTitle",
                    "ownerFirstName",
                    "ownerLastName",
                    "refOwnerNationality",
                    "ownerAge",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOwnerPersonType?.key == '2';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refRequesterCompanyType",
                    "requesterName",
                    "requesterShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refRequesterPersonType?.key == '1';
            },
        },
        {
            check: ({ field }) => {
                return [
                    "refOwnerCompanyType",
                    "ownerName",
                    "ownerShareholdingTh",
                ].includes(field?.key);
            },
            visibleField: ({ modelRef }) => {
                return modelRef.refOwnerPersonType?.key == '1';
            },
        },
        // Address Owner
        // Address
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addressOwners\\.[^\\.]+\\.(refAddressType|fax|latitude|longitude|email|tel)$`,
                    "g"
                ).test(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^addressOwners\\.[^\\.]+\\.(noTh|roomTh|buildingTh|floorTh|villageTh|mooTh|soiTh|roadTh|refProvince|refAmphur|refTambon|postCode)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return new RegExp(
                    `^attachments\\.[^\\.]+\\.(documentName|(attribute\\.(documentNo|documentDate|documentExpiredDate))|size)$`,
                    "g"
                ).test(field?.key);
            },
            inputPropField: commonInputPropField({
                disabledStatuses: ["waitAcceptRequest", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel"],
                disabledRequestTypes: ["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"]
            })
        },
        {
            check: ({ componentKey }) => {
                return [
                    "attachmentVesselIdentities",
                    "attachmentPositionVesselIdentities",
                    "attachmentHeadVessels",
                    "attachmentFullVessels",
                ].includes(componentKey);
            },
            // visibleField: () => {
            //     return false;
            // },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { viewOnly } = props;
                let canCreate = false;
                let canDelete = false;
                if ([undefined, "draft", "waitModify"].includes(initialModel.refStatus?.key)) {
                    canCreate = !viewOnly || canCreate;
                    canDelete = !viewOnly || canDelete;
                }
                if (["renewLicense", "cancelLicense", "transferLicense", "requestReplacement"].includes(modelRef.refRequestType?.key)) {
                    canCreate = false;
                    canDelete = false;
                }
                return { canCreate, canDelete };
            }
        },
        /* Show Only For Dof Center & For Authorized   */
        {
            check: ({ field }) => {
                return [
                    "refPrintStatus",
                    "printReportBtn",
                    "proposeRevoke",
                    "refProposeRevokeStatus",
                    "proposeRevokeRemark",
                    "attachmentProposeRevokes",
                    "revokeResult",
                    "suspendedResult",
                    "allStatusResult",
                    "refLicenseStatus",
                    "licenseRevokeRemark",
                    "attachmentRevokes",
                ].includes(field?.key);
            },
            visibleField: ({ props, modelRef }) => {
                const { menuContext } = props;
                let visible = false;
                if (have({menuContext, keys: ["forDofCenter", "forAuthorized"]})
                    || modelRef.createBy === store.state.resource.auth.info.user?.username) {
                    visible = true || visible;
                }
                return visible;
            },
        },
        {
            check: ({ field }) => {
                return [
                    "licenseConditionRemark"
                ].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false
                if (have({menuContext, keys: ["forDofCenter", "forAuthorized"]})) {
                    enabled = !viewOnly || enabled
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "revokeResult",
                    "suspendedResult",
                    "allStatusResult",
                    "refLicenseStatus",
                    "licenseRevokeRemark",
                    "attachmentRevokes",
                ].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false
                if (have({menuContext, keys: ["forAuthorized"]})) {
                    enabled = !viewOnly || enabled
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refProposeRevokeStatus",
                    "proposeRevokeRemark",
                    "attachmentProposeRevokes",
                ].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false
                if (have({menuContext, keys: ["forDofCenter"]})) {
                    enabled = !viewOnly || enabled
                }
                return { disabled: !enabled }
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refProposeRevokeStatus",
                    "proposeRevokeRemark",
                    "attachmentProposeRevokes",
                ].includes(field?.key);
            },
            inputPropField: ({ props }) => {
                const { viewOnly, menuContext } = props;
                let enabled = false
                if (have({menuContext, keys: ["forAuthorized"]})) {
                    enabled = !viewOnly || enabled
                }
                return { disabled: !enabled }
            }
        },
        /* Enable Only who create this request */
        {
            check: ({ field }) => {
                return [
                    "refAppealLicenseStatus",
                    "appealLicenseRemark",
                    "attachmentAppealLicenses",
                    "appealLicenseRemark"
                ].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                let enabled = false
                if (modelRef.createBy === store.state.resource.auth.info.user?.username) {
                    if(['revoke'].includes(modelRef.refLicenseStatus?.key)
                        && modelRef.isCanAppealLicense){
                        enabled = !viewOnly || enabled
                    }
                }
                return { disabled: !enabled }
            }
        }
    ]
};
